var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6002 65.5417L34.7502 25.3334H25.3335V58.6667H33.6668V37.6084L59.0293 70.6625C51.7425 74.9981 43.0773 76.3937 34.7977 74.5654C26.5181 72.7371 19.2465 67.8222 14.463 60.8213C9.6795 53.8204 7.74375 45.2597 9.04978 36.8818C10.3558 28.504 14.8055 20.9387 21.493 15.726C28.1804 10.5133 36.6031 8.04508 45.0463 8.82371C53.4895 9.60234 61.3187 13.5693 66.9401 19.9171C72.5615 26.2649 75.5525 34.5164 75.3044 42.9918C75.0562 51.4672 71.5875 59.5295 65.6043 65.5375M42.0002 83.6667C65.0127 83.6667 83.6668 65.0125 83.6668 42C83.6668 18.9875 65.0127 0.333374 42.0002 0.333374C18.9877 0.333374 0.333496 18.9875 0.333496 42C0.333496 65.0125 18.9877 83.6667 42.0002 83.6667ZM50.3335 42V25.3334H58.6668V42H50.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0328d86fa40a51894bc5602a3bae0798.svg";
export { ForwardRef as ReactComponent };